import { render, staticRenderFns } from "./AvatarMessageChip.vue?vue&type=template&id=f574a582&scoped=true"
import script from "./AvatarMessageChip.vue?vue&type=script&lang=js"
export * from "./AvatarMessageChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f574a582",
  null
  
)

export default component.exports